import React, {useEffect, useRef, useState} from 'react';
import styles from './Timestamp.module.scss';
import Tooltip from "../Tooltip/Tooltip";
import moment from "moment";
import store from "../../../store";
import {$t} from "../../../helpers/translator";

const Timestamp = (props) => {
    const [time, setTime] = useState(null);         //time provided to component (from db)
    const [userTime, setUserTime] = useState(null); //user's time
    const [tooltip, setTooltip] = useState('');

    useEffect(() => {
        // console.log(props.time)
        if (!props.time) {
            return;
        }
        setTime(moment(props.time));
        let user = store.getState().auth.user;
        let selectedTimeZone = user !== null && user.timezone ? user.timezone : moment.tz.guess()
        let guessed = user !== null ? !user.timezone : true;   //true if user did not enter a timezone
        setUserTime(moment(props.time));
        setTooltip(`${moment(props.time).format('YYYY-MM-DD HH:mm:ss')} (${selectedTimeZone}${guessed ? ' '+$t('global.general.autodetected') : ''})`)
    }, [props.time]);

    return (
        <div className={styles.container}>
            {props.time && userTime ?
                <Tooltip content={tooltip ? tooltip : ''}>
                    <div>{userTime.fromNow()}</div>
                </Tooltip>
            :
            <div/>}
        </div>
    );
}

export default Timestamp;
